import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { Commessa } from '../../models/commessa';
import { Statocommessa } from '../../models/statocommessa';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { configurazione } from '../../../configurazioni/configurazione';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-commesse',
  templateUrl: './commesse.component.html',
  styleUrls: ['./commesse.component.css']
})
export class CommesseComponent implements OnInit {
  selectedValueStato:string;
  selectedValueDataingresso:Date;
  selectedValueDatafine:Date;
  commesse: Commessa[]=[];
  commesseincache: Commessa[]=[];
  commesseselezionate: Commessa[]=[];
  commessa: Commessa;
  stati: Statocommessa[];
  stato: Statocommessa;
  filtroTargaveicolo: string;
  filtroCliente: string;

//  currentAzienda:Azienda;
  displayedColumns: string[] = [
    "sel",
    "Codice",
    "Numerocommessa",
    "Codiceazienda",
    "Nomecliente",
    "Targaveicolo",
    "Dataingresso",
    "Datafine",
    "Tot",
    "Eng",
    "Ele",
    "Codicetipocommessa",
    "Nometipocommessa",
    "Note",
    "Noteofficina",
    "Stato",
    "Assegnatario",
    "build",
    "edit"];

    displayedColumns2: string[] = [
      "Marcaveicolo",
      "Modelloveicolo",
      "Telaioveicolo",
      "Marcafrigo",
      "Matricolafrigo",
      "Modellofrigo",
      "Annofabbricazionefrigo"];

  sortedDirection:Map<string, boolean>=new Map<string, boolean>();

  dataSource = new MatTableDataSource<Commessa>(this.commesse);
  dataSource2 = new MatTableDataSource<Commessa>(this.commesseselezionate);

  @ViewChild('paginator') paginator: MatPaginator;
  selection = new SelectionModel<Commessa>(true, []);

  constructor(private router: Router, private commonService: CommonService) {
    this.commessa=new Commessa();
    this.filtroTargaveicolo="";
    this.filtroCliente="";
  }

  ngOnInit() {
    this.commonService.getAllStaticommessa().subscribe((res) => {
        this.stati = res;
        if (this.commonService.selectedStatocommessa!=undefined) {
            this.selectedValueStato=this.commonService.selectedStatocommessa.Nome;
        }
/*
        this.commesse.forEach(element => {
          if (element.Codice === this.commonService.currentAziendaCodice){
            this.stato=element;
            this.selectedValueAzienda=this.azienda.Nome;
          }
        });
*/
  //      this.manageChangeAzienda();
        this.manageChangeStato();
  //      this.aggiornaLista();
    });

    this.dataSource.paginator = this.paginator;
    this.sortedDirection.set("Codice",true);
    this.sortedDirection.set("Numerocommessa",true);
    this.sortedDirection.set("Codiceazienda",true);
    this.sortedDirection.set("Nomecliente",true);
    this.sortedDirection.set("Dataingresso",true);
    this.sortedDirection.set("Datafine",true);
    this.sortedDirection.set("Tot",true);
    this.sortedDirection.set("Eng",true);
    this.sortedDirection.set("Ele",true);
    this.sortedDirection.set("Marcaveicolo",true);
    this.sortedDirection.set("Modelloveicolo",true);
    this.sortedDirection.set("Targaveicolo",true);
    this.sortedDirection.set("Telaioveicolo",true);
    this.sortedDirection.set("Marcafrigo",true);
    this.sortedDirection.set("Matricolafrigo",true);
    this.sortedDirection.set("Modellofrigo",true);
    this.sortedDirection.set("Annofabbricazionefrigo",true);
    this.sortedDirection.set("Codicetipocommessa",true);
    this.sortedDirection.set("Nometipocommessa",true);
    this.sortedDirection.set("Note",true);
    this.sortedDirection.set("Noteofficina",true);
    this.sortedDirection.set("Stato",true);
    this.sortedDirection.set("Cognomeassegnatario",true);
    this.sortedDirection.set("build",true);
    this.sortedDirection.set("edit",true);
  }

  manageChangeStato(){
    if (this.selectedValueStato!=undefined){
      this.stati.forEach(element => {
        if (this.selectedValueStato === element.Nome){
          this.stato=element;
        }
      });
    }
    this.aggiornaLista();
  }

  selezionata(commessa:Commessa){
    console.log("");
    /*
    const indexOfObject = this.articoliselezionati.findIndex((element) => {
      return element.Codicearticolo === articolo.Codicearticolo;
    });
    if (indexOfObject !== -1) {
      this.articoliselezionati.splice(indexOfObject, 1);
    }else{
      this.articoliselezionati.push(articolo);
    }
    */
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }

  manageCheckboxclick(event, c:Commessa){
    this.commesseselezionate=[];
    this.commessa=c;
    let found:boolean=false;
    this.selection.selected.forEach(row => {
      if (row.Codice!=c.Codice){
        this.selection.deselect(row);
      }else{
        found=true;
        this.commesseselezionate.push(c);
      }
    });
    if (!found){
      this.commessa=new Commessa();
      this.commesseselezionate=[];
    }
    this.dataSource2 = new MatTableDataSource<Commessa>(this.commesseselezionate);

    event.stopPropagation();
  }

  cancel(){
    this.selectedValueStato="";
    this.selectedValueDataingresso=undefined;
    this.selectedValueDatafine=undefined;
    this.filtroCliente="";
    this.filtroTargaveicolo="";
    this.stato=new Statocommessa();
    this.commessa=new Commessa();
    this.selection.clear();
    this.commesseincache=[];
    this.aggiornaLista();
  }

  delete(commessa: Commessa): void {
    this.commonService.deleteCommessa(commessa).subscribe(data => {
      this.commesse = this.commesse.filter(c => c !== commessa);
    });
  }


  aggiornaLista(){
    let templistacommesse:Commessa[]=[];
    this.commesse=[];
  //  if (this.stato!=undefined && this.stato.Nome!=undefined && this.stato.Nome!=""){
     this.commonService.getAllCommesse().subscribe((res) => {
       templistacommesse = res;
       if (this.stato!=undefined && this.stato.Nome!=undefined && this.stato.Nome!=""){
          templistacommesse.forEach(element => {
              const commessa:Commessa=element;
              if (commessa.Statocommessa.Nome===this.stato.Nome){
                this.commesse.push(commessa);
              }
            });
       }else{
         this.commesse=res;
       }
       this.refreshLista(this.commesse);
      });

    }

   refreshLista(listacommesse:Commessa[]){
     this.commesse=listacommesse;
     this.commesseincache=listacommesse;
     this.dataSource = new MatTableDataSource<Commessa>(this.commesse);
     this.dataSource.paginator = this.paginator;
   }

  new(){
    this.commonService.selectedCommessa=undefined;
    this.router.navigate(['addcommessa']);
  }
  edit(commessa: Commessa): void {
      this.commonService.selectedCommessa=commessa;
      this.router.navigate(['addcommessa']);
  }

  build(commessa: Commessa): void {
      this.commonService.selectedCommessa=commessa;
      this.router.navigate(['lavorazioni']);
  }

  getConfigurazione(){
    return configurazione.commessa;
  }


  isDetailsHidden(){
    if (this.selection.selected.length===0){
      return 'none';
    }else{
      return'';
    }
  }

  onFiltroTargaveicoloKeyup(event:any){
    this.commesse=this.commesseincache;
    if (event.target.value!=undefined){
      this.filtroCliente="";
      this.commesse = this.commesse.filter(c=> c.Targaveicolo.indexOf(event.target.value)>-1);
      this.dataSource = new MatTableDataSource<Commessa>(this.commesse);
    }
  }

  onFiltroClienteKeyup(event:any){
    this.commesse=this.commesseincache;
    if (event.target.value!=undefined){
      this.filtroTargaveicolo="";
      this.commesse = this.commesse.filter(c=> c.Nomecliente.indexOf(event.target.value)>-1);
      this.dataSource = new MatTableDataSource<Commessa>(this.commesse);
    }
  }


  onFiltroDataingressoDatechange(event:any){
    let di=this.dateToNumber(this.selectedValueDataingresso);
    let df=this.dateToNumber(this.selectedValueDatafine);
    this.commesse=[];

      this.commesseincache.forEach(c => {
        let dic=this.dateToNumber(c.Dataingresso);
        let dfc=this.dateToNumber(c.Datafine);
        if (di<=dic && dfc<=df){
          this.commesse.push(c);
        }
      })
      this.dataSource = new MatTableDataSource<Commessa>(this.commesse);

  }

  dateToNumber(d: Date): number {
    let s:string='99991231';
    if(d!=undefined && d!=null){

      if (d instanceof Date){
//        console.log("--->"+d);
      }else{
        let s2=String(d).replaceAll('-','')
//        console.log("not date:"+s2);
        return Number(s2);
      }

      let month:string = (d.getMonth()+1).toString();
      if ((d.getMonth()+1)<10){
        month='0'+month;
      }
      let year = d.getFullYear().toString();
      let day = d.getDate().toString();
      s=year+month+day;
    }
    return Number(s);
  }


  manageClick(attributo: string){
    let tempList:Commessa[];
    tempList=this.commesse;
    let direction=this.sortedDirection.get(attributo);

    tempList.sort((a, b) => {
       var typeA = "";
       var typeB = "";
       if (a[attributo]!=null){
         if (isNaN(b[attributo]))
            typeA = a[attributo].toLowerCase();
         else
            typeA = a[attributo].toString();
       }
       if (b[attributo]!=null){
         if (isNaN(b[attributo]))
            typeB = b[attributo].toLowerCase();
          else
            typeB = b[attributo].toString();
       }
         if (direction){
           if (typeA > typeB){
             return -1;
           }else if (typeA < typeB){
              return 1;
           }else{
             return 0;
           }
         }else{
           if (typeA < typeB){
             return -1;
           }else if (typeA > typeB){
              return 1;
           }else{
             return 0;
           }
         }
     });
     direction=!direction;
     this.sortedDirection.set(attributo,direction);
     this.dataSource = new MatTableDataSource<Commessa>(this.commesse);

   }

}
